import React, { useEffect, useState} from 'react'
import styles from './WorkReportingTemplates.module.css'
import {Button, DialogActions, DialogContent, DialogTitle} from "@material-ui/core";
import {Alert, Dialog, FormControl, Grid} from "@mui/material";
import AutocompleteSelect from "../../../components/common/inputs/AutoCompleteSelectInput";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import HookForm from "../../../components/common/HookForm";
import {useForm} from "react-hook-form";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import LoadingBackdrop from "../../../components/common/LoadingBackdrop";

interface FormData {
    divisionid: number
    woid: number
    pmid: number
    addressid: number
}
const CreateSchedule = (params) => {
    const formMethods = useForm<FormData>()
    const { setValue, watch, reset } = formMethods
    const [snackbarOpen, setSnackbarOpen] = React.useState({ open: false, message: '' })
    const [loadingBackdrop, setLoadingBackdrop] = React.useState(false)
    const onSubmit = async () => {
        params.setScheduleCreate(true)
        params.setCreateScheduleShow(false)
    }
    const handleSnackbarClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackbarOpen({ open: false, message: ""  });
    }


    return (
            <Dialog fullWidth={true} open={params.createScheduleShow}>
                <LoadingBackdrop open={loadingBackdrop} />
                {/*<DialogTitle>Create a new schedule</DialogTitle>*/}
                <>
                    <Snackbar
                        open={snackbarOpen.open}
                        autoHideDuration={4000}
                        onClose={handleSnackbarClose}
                        anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                    >
                        <Alert severity="success">
                            {snackbarOpen.message}
                        </Alert>
                    </Snackbar>
                </>
                <DialogContent>
                            <Box>
                                <Grid
                                    container
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="center"
                                    height={'100%'}
                                    width={'100%'}
                                >
                                    <>
                                        <Grid item xl={12} md={12} xs={12}>
                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                width={'100%'}
                                            >
                                                <Typography variant="subtitle1" gutterBottom>
                                                    Create new work reporting template.
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    </>
                                </Grid>
                            </Box>
                        <DialogActions>
                            <Button onClick={()=> {
                                params.setScheduleCreate(false)
                                params.setCreateScheduleShow(false)
                            }} variant="contained" style={{width: '100%'}}>
                                Cancel
                            </Button>
                            <Button onClick={()=> {onSubmit()}} type="submit" variant="contained" style={{width: '100%'}}>
                                Create
                            </Button>
                        </DialogActions>
                </DialogContent>
            </Dialog>
    )
}
export default CreateSchedule